import type { Product } from "../types";
import intelCoreI312100FImage from "../images/products/Intel Core i3-12100F.png";
import amdRyzen34100Image from "../images/products/AMD Ryzen 3 4100.png";
import nvidiaGTX1650Image from "../images/products/NVIDIA GTX.png";
import amdRX6400Image from "../images/products/AMD RX.png";
import wdBlueSN5702TBImage from "../images/products/WD BLUE S.png";
import samsung970EVOPlus1TBImage from "../images/products/SAMSUNG 970.png";
import wdBlue2TBHDDImage from "../images/products/WD BLUE 2.png";
import msiB660MAWiFiImage from "../images/products/MSI wifi (1).png";
import razerBlackWidowV3Image from "../images/products/RAZER BLACKWIDOW.png";
import razerDeathAdderV2Image from "../images/products/RAZER DEATHV2.png";
import idCoolingSE224XTImage from "../images/products/ID COOLING.png";
import thermaltakeUX200Image from "../images/products/THERMALTAKE U.png";
import intelCoreI310100FImage from "../images/products/Intel Core i3-10100F.png";
import amdRyzen33100Image from "../images/products/AMD Ryzen 3 3100G.png";
import nvidiaGTX1630Image from "../images/products/NVIDIAGTX 16.png";
import amdRX550Image from "../images/products/AMD RX.png";
import kingstonA400480GBImage from "../images/products/KINGSTON A400.png";
import seagateBarracuda1TBImage from "../images/products/SEAGATE.png";
import msiH610MBImage from "../images/products/MSIH6.png";
import gigabyteA520MS2HImage from "../images/products/GIGABYTE A52.png";
import redragonK582Image from "../images/products/REDRAGON K5.png";
import razerDeathAdderEssentialImage from "../images/products/RAZER ESSENTIAL.png";
import coolerMasterHyperH410RImage from "../images/products/COOLER MASTER.png";
import deepcoolGAMMAXX200TImage from "../images/products/DEEP COOL.png";
import intelCoreI310105FImage from "../images/products/Intel Core i3-10105F.png";
import amdRyzen33200GImage from "../images/products/AMD Ryzen 3 3200G.png";
import crucialBX500480GBImage from "../images/products/CRUCIAL BX.png";
import toshibaP3001TBImage from "../images/products/TOSHIBA P300.png";
import redragonK630Image from "../images/products/REDRAGON K6.png";
import logitechG102Image from "../images/products/LOGITECH.png";

export const products: Product[] = [
  // Processors
  {
    id: 1,
    name: "Intel Core i3-12100F",
    description: "12th Gen Intel Core processor with 4 cores and 8 threads",
    price: 27996,
    originalPrice: 30795,
    image: intelCoreI312100FImage,
    category: "processors",
    rating: 4.7,
    discount: 9,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "4 cores / 8 threads",
      "Up to 4.3 GHz boost clock",
      "12MB L3 cache",
      "No integrated graphics",
      "PCIe 4.0 support"
    ],
    specifications: {
      brand: "Intel",
      model: "12100F",
      cores: 4,
      threads: 8,
      baseSpeed: "3.3 GHz",
      maxSpeed: "4.3 GHz",
      cache: "12MB L3"
    }
  },
  {
    id: 2,
    name: "AMD Ryzen 3 4100",
    description: "AMD's entry-level processor with 4 cores and 8 threads",
    price: 25196,
    originalPrice: 27995,
    image: amdRyzen34100Image,
    category: "processors",
    rating: 4.6,
    discount: 10,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "4 cores / 8 threads",
      "Up to 4.0 GHz boost clock",
      "4MB L3 cache",
      "Radeon Graphics",
      "PCIe 3.0 support"
    ],
    specifications: {
      brand: "AMD",
      model: "4100",
      cores: 4,
      threads: 8,
      baseSpeed: "3.8 GHz",
      maxSpeed: "4.0 GHz",
      cache: "4MB L3"
    }
  },

  // Graphics Cards
  {
    id: 3,
    name: "NVIDIA GTX 1650",
    description: "Entry-level graphics card with 4GB GDDR6 memory",
    price: 44793,
    originalPrice: 47592,
    image: nvidiaGTX1650Image,
    category: "graphics-cards",
    rating: 4.5,
    discount: 6,
    stock: 8,
    quantity: 1,
    sold: 4,
    features: [
      "4GB GDDR6 memory",
      "12 Gbps memory speed",
      "896 CUDA cores",
      "NVIDIA Encoder",
      "DirectX 12 support"
    ],
    specifications: {
      brand: "NVIDIA",
      model: "GTX 1650",
      memory: "4GB GDDR6",
      memorySpeed: "12 Gbps",
      cudaCores: 896
    }
  },
  {
    id: 4,
    name: "AMD RX 6400",
    description: "Entry-level GPU with 4GB GDDR6 memory",
    price: 41994,
    originalPrice: 44793,
    image: amdRX6400Image,
    category: "graphics-cards",
    rating: 4.4,
    discount: 6,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "4GB GDDR6 memory",
      "14 Gbps memory speed",
      "12 compute units",
      "AMD FSR support",
      "DirectX 12 support"
    ],
    specifications: {
      brand: "AMD",
      model: "RX 6400",
      memory: "4GB GDDR6",
      memorySpeed: "14 Gbps",
      computeUnits: 12
    }
  },

  // Storage Solutions
  {
    id: 5,
    name: "WD Blue SN570 2TB",
    description: "Fast NVMe SSD with 2TB storage",
    price: 44793,
    originalPrice: 47592,
    image: wdBlueSN5702TBImage,
    category: "storage",
    rating: 4.6,
    discount: 6,
    stock: 20,
    quantity: 1,
    sold: 12,
    features: [
      "2TB storage capacity",
      "3500MB/s read speed",
      "3000MB/s write speed",
      "5-year warranty",
      "Low power consumption"
    ],
    specifications: {
      brand: "Western Digital",
      model: "SN570",
      capacity: "2TB",
      interface: "NVMe PCIe 3.0",
      readSpeed: "3500MB/s",
      writeSpeed: "3000MB/s"
    }
  },
  {
    id: 6,
    name: "Samsung 970 EVO Plus 1TB",
    description: "Premium NVMe SSD with 1TB storage",
    price: 27996,
    originalPrice: 30795,
    image: samsung970EVOPlus1TBImage,
    category: "storage",
    rating: 4.7,
    discount: 9,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "1TB storage capacity",
      "3500MB/s read speed",
      "3300MB/s write speed",
      "5-year warranty",
      "Samsung Magician software"
    ],
    specifications: {
      brand: "Samsung",
      model: "970 EVO Plus",
      capacity: "1TB",
      interface: "NVMe PCIe 3.0",
      readSpeed: "3500MB/s",
      writeSpeed: "3300MB/s"
    }
  },

  // Motherboards
  {
    id: 7,
    name: "WD Blue 2TB HDD",
    description: "Reliable hard drive with 2TB storage",
    price: 16797,
    originalPrice: 19596,
    image: wdBlue2TBHDDImage,
    category: "storage",
    rating: 4.4,
    discount: 14,
    stock: 25,
    quantity: 1,
    sold: 15,
    features: [
      "2TB storage capacity",
      "7200 RPM spindle speed",
      "256MB cache",
      "2-year warranty",
      "Low power consumption"
    ],
    specifications: {
      brand: "Western Digital",
      model: "Blue",
      capacity: "2TB",
      interface: "SATA 6Gb/s",
      spindleSpeed: "7200 RPM",
      cache: "256MB"
    }
  },
  {
    id: 8,
    name: "MSI B660M-A WiFi",
    description: "Micro-ATX motherboard with WiFi support",
    price: 44793,
    originalPrice: 47592,
    image: msiB660MAWiFiImage,
    category: "motherboards",
    rating: 4.5,
    discount: 6,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "LGA 1700 socket",
      "DDR5 memory support",
      "WiFi 6E",
      "PCIe 4.0 slots",
      "2.5G LAN"
    ],
    specifications: {
      brand: "MSI",
      model: "B660M-A WiFi",
      chipset: "B660",
      socket: "LGA 1700",
      memoryType: "DDR5",
      wifi: "WiFi 6E"
    }
  },

  // Peripherals
  {
    id: 9,
    name: "Razer BlackWidow V3",
    description: "Mechanical gaming keyboard with Razer Green switches",
    price: 27996,
    originalPrice: 30795,
    image: razerBlackWidowV3Image,
    category: "peripherals",
    rating: 4.6,
    discount: 9,
    stock: 8,
    quantity: 1,
    sold: 4,
    features: [
      "Razer Green switches",
      "RGB backlighting",
      "Aluminum frame",
      "PBT keycaps",
      "USB-C connection"
    ],
    specifications: {
      brand: "Razer",
      model: "BlackWidow V3",
      switchType: "Razer Green",
      connection: "USB-C",
      backlight: "RGB",
      material: "Aluminum frame"
    }
  },
  {
    id: 10,
    name: "Razer DeathAdder V2",
    description: "Ergonomic gaming mouse with optical switches",
    price: 19596,
    originalPrice: 22395,
    image: razerDeathAdderV2Image,
    category: "peripherals",
    rating: 4.5,
    discount: 12,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "20K DPI sensor",
      "Optical mouse switches",
      "RGB lighting",
      "Ergonomic design",
      "Speedflex cable"
    ],
    specifications: {
      brand: "Razer",
      model: "DeathAdder V2",
      sensor: "20K DPI",
      switches: "Optical",
      connection: "USB",
      lighting: "RGB"
    }
  },

  // Cooling Solutions
  {
    id: 11,
    name: "ID-Cooling SE-224-XT",
    description: "Tower air cooler with 120mm fan",
    price: 13998,
    originalPrice: 16797,
    image: idCoolingSE224XTImage,
    category: "cooling",
    rating: 4.5,
    discount: 17,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "120mm fan",
      "Intel/AMD support",
      "Direct contact heatpipes",
      "Low noise operation",
      "2-year warranty"
    ],
    specifications: {
      brand: "ID-Cooling",
      model: "SE-224-XT",
      type: "Air",
      fan: "120mm",
      height: "154mm",
      socketSupport: "Intel/AMD"
    }
  },
  {
    id: 12,
    name: "Thermaltake UX200",
    description: "Tower air cooler with 120mm fan",
    price: 16797,
    originalPrice: 19596,
    image: thermaltakeUX200Image,
    category: "cooling",
    rating: 4.4,
    discount: 14,
    stock: 25,
    quantity: 1,
    sold: 12,
    features: [
      "120mm fan",
      "Intel/AMD support",
      "Direct contact heatpipes",
      "Low noise operation",
      "2-year warranty"
    ],
    specifications: {
      brand: "Thermaltake",
      model: "UX200",
      type: "Air",
      fan: "120mm",
      height: "154mm",
      socketSupport: "Intel/AMD"
    }
  },

  // Additional Processors
  {
    id: 13,
    name: "Intel Core i3-10100F",
    description: "10th Gen Intel Core processor with 4 cores and 8 threads",
    price: 25196,
    originalPrice: 27995,
    image: intelCoreI310100FImage,
    category: "processors",
    rating: 4.5,
    discount: 10,
    stock: 18,
    quantity: 1,
    sold: 10,
    features: [
      "4 cores / 8 threads",
      "Up to 4.3 GHz boost clock",
      "6MB L3 cache",
      "No integrated graphics",
      "PCIe 3.0 support"
    ],
    specifications: {
      brand: "Intel",
      model: "10100F",
      cores: 4,
      threads: 8,
      baseSpeed: "3.6 GHz",
      maxSpeed: "4.3 GHz",
      cache: "6MB L3"
    }
  },
  {
    id: 14,
    name: "AMD Ryzen 3 3100",
    description: "AMD's entry-level processor with 4 cores and 8 threads",
    price: 27996,
    originalPrice: 30795,
    image: amdRyzen33100Image,
    category: "processors",
    rating: 4.6,
    discount: 9,
    stock: 15,
    quantity: 1,
    sold: 7,
    features: [
      "4 cores / 8 threads",
      "Up to 3.9 GHz boost clock",
      "16MB L3 cache",
      "Radeon Graphics",
      "PCIe 3.0 support"
    ],
    specifications: {
      brand: "AMD",
      model: "3100",
      cores: 4,
      threads: 8,
      baseSpeed: "3.6 GHz",
      maxSpeed: "3.9 GHz",
      cache: "16MB L3"
    }
  },

  // Additional Graphics Cards
  {
    id: 15,
    name: "NVIDIA GTX 1630",
    description: "Entry-level graphics card with 4GB GDDR6 memory",
    price: 41994,
    originalPrice: 44793,
    image: nvidiaGTX1630Image,
    category: "graphics-cards",
    rating: 4.4,
    discount: 6,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "4GB GDDR6 memory",
      "12 Gbps memory speed",
      "512 CUDA cores",
      "NVIDIA Encoder",
      "DirectX 12 support"
    ],
    specifications: {
      brand: "NVIDIA",
      model: "GTX 1630",
      memory: "4GB GDDR6",
      memorySpeed: "12 Gbps",
      cudaCores: 512
    }
  },
  {
    id: 16,
    name: "AMD RX 550",
    description: "Entry-level GPU with 4GB GDDR5 memory",
    price: 33595,
    originalPrice: 36394,
    image: amdRX550Image,
    category: "graphics-cards",
    rating: 4.3,
    discount: 8,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "4GB GDDR5 memory",
      "7 Gbps memory speed",
      "8 compute units",
      "AMD FSR support",
      "DirectX 12 support"
    ],
    specifications: {
      brand: "AMD",
      model: "RX 550",
      memory: "4GB GDDR5",
      memorySpeed: "7 Gbps",
      computeUnits: 8
    }
  },

  // Additional Storage Solutions
  {
    id: 17,
    name: "Kingston A400 480GB",
    description: "SATA SSD with up to 500 MB/s read speed",
    price: 13998,
    originalPrice: 16797,
    image: kingstonA400480GBImage,
    category: "storage",
    rating: 4.6,
    discount: 17,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "480GB storage capacity",
      "500 MB/s read speed",
      "450 MB/s write speed",
      "SATA interface",
      "3-year warranty"
    ],
    specifications: {
      brand: "Kingston",
      model: "A400",
      capacity: "480GB",
      interface: "SATA",
      readSpeed: "500 MB/s",
      writeSpeed: "450 MB/s"
    }
  },
  {
    id: 18,
    name: "Seagate Barracuda 1TB",
    description: "SATA HDD for mass storage",
    price: 13998,
    originalPrice: 16797,
    image: seagateBarracuda1TBImage,
    category: "storage",
    rating: 4.5,
    discount: 17,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "1TB storage capacity",
      "7200 RPM",
      "64MB cache",
      "SATA interface",
      "2-year warranty"
    ],
    specifications: {
      brand: "Seagate",
      model: "Barracuda",
      capacity: "1TB",
      interface: "SATA",
      rpm: "7200",
      cache: "64MB"
    }
  },

  // Additional Motherboards
  {
    id: 19,
    name: "MSI H610M-B",
    description: "Intel H610 motherboard with DDR4 support",
    price: 25196,
    originalPrice: 27995,
    image: msiH610MBImage,
    category: "motherboards",
    rating: 4.4,
    discount: 10,
    stock: 8,
    quantity: 1,
    sold: 4,
    features: [
      "Intel H610 chipset",
      "DDR4 memory support",
      "PCIe 3.0 slots",
      "1G LAN",
      "USB 3.2 Gen1"
    ],
    specifications: {
      brand: "MSI",
      model: "H610M-B",
      chipset: "H610",
      socket: "LGA 1700",
      memoryType: "DDR4",
      maxMemory: "64GB"
    }
  },
  {
    id: 20,
    name: "GIGABYTE A520M-S2H",
    description: "AMD A520 motherboard with PCIe 3.0",
    price: 27996,
    originalPrice: 30795,
    image: gigabyteA520MS2HImage,
    category: "motherboards",
    rating: 4.5,
    discount: 9,
    stock: 10,
    quantity: 1,
    sold: 5,
    features: [
      "AMD A520 chipset",
      "DDR4 memory support",
      "PCIe 3.0 slots",
      "1G LAN",
      "USB 3.2 Gen1"
    ],
    specifications: {
      brand: "GIGABYTE",
      model: "A520M-S2H",
      chipset: "A520",
      socket: "AM4",
      memoryType: "DDR4",
      maxMemory: "64GB"
    }
  },

  // Additional Peripherals
  {
    id: 21,
    name: "Redragon K582",
    description: "Mechanical keyboard with RGB and numpad",
    price: 19596,
    originalPrice: 22395,
    image: redragonK582Image,
    category: "peripherals",
    rating: 4.5,
    discount: 12,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Outemu Blue switches",
      "RGB backlighting",
      "Aluminum frame",
      "Wired connectivity",
      "PBT keycaps"
    ],
    specifications: {
      brand: "Redragon",
      model: "K582",
      type: "Mechanical",
      switches: "Outemu Blue",
      connectivity: "Wired",
      backlight: "RGB"
    }
  },
  {
    id: 22,
    name: "Razer DeathAdder Essential",
    description: "Ergonomic gaming mouse with RGB",
    price: 16797,
    originalPrice: 19596,
    image: razerDeathAdderEssentialImage,
    category: "peripherals",
    rating: 4.6,
    discount: 14,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "6400 DPI sensor",
      "RGB lighting",
      "Ergonomic design",
      "Wired connectivity",
      "Programmable buttons"
    ],
    specifications: {
      brand: "Razer",
      model: "DeathAdder Essential",
      sensor: "6400 DPI",
      connectivity: "Wired",
      buttons: "5",
      weight: "96g"
    }
  },

  // Additional Cooling Solutions
  {
    id: 23,
    name: "Cooler Master Hyper H410R",
    description: "Tower air cooler with 92mm fan",
    price: 13998,
    originalPrice: 16797,
    image: coolerMasterHyperH410RImage,
    category: "cooling",
    rating: 4.4,
    discount: 17,
    stock: 12,
    quantity: 1,
    sold: 6,
    features: [
      "92mm fan",
      "Intel/AMD support",
      "Direct contact heatpipes",
      "Low noise operation",
      "2-year warranty"
    ],
    specifications: {
      brand: "Cooler Master",
      model: "Hyper H410R",
      type: "Air",
      fan: "92mm",
      height: "138mm",
      socketSupport: "Intel/AMD"
    }
  },
  {
    id: 24,
    name: "Deepcool GAMMAXX 200T",
    description: "Tower air cooler with 120mm fan",
    price: 13998,
    originalPrice: 16797,
    image: deepcoolGAMMAXX200TImage,
    category: "cooling",
    rating: 4.5,
    discount: 17,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "120mm fan",
      "Intel/AMD support",
      "Direct contact heatpipes",
      "Low noise operation",
      "2-year warranty"
    ],
    specifications: {
      brand: "Deepcool",
      model: "GAMMAXX 200T",
      type: "Air",
      fan: "120mm",
      height: "155mm",
      socketSupport: "Intel/AMD"
    }
  },

  // Additional Products
  {
    id: 25,
    name: "Intel Core i3-10105F",
    description: "10th Gen Intel Core processor with 4 cores and 8 threads",
    price: 27996,
    originalPrice: 30795,
    image: intelCoreI310105FImage,
    category: "processors",
    rating: 4.5,
    discount: 9,
    stock: 25,
    quantity: 1,
    sold: 12,
    features: [
      "4 cores / 8 threads",
      "Up to 4.4 GHz boost clock",
      "6MB L3 cache",
      "No integrated graphics",
      "PCIe 3.0 support"
    ],
    specifications: {
      brand: "Intel",
      model: "10105F",
      cores: 4,
      threads: 8,
      baseSpeed: "3.7 GHz",
      maxSpeed: "4.4 GHz",
      cache: "6MB L3"
    }
  },
  {
    id: 26,
    name: "AMD Ryzen 3 3200G",
    description: "AMD's entry-level processor with 4 cores and 4 threads",
    price: 25196,
    originalPrice: 27995,
    image: amdRyzen33200GImage,
    category: "processors",
    rating: 4.4,
    discount: 10,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "4 cores / 4 threads",
      "Up to 4.0 GHz boost clock",
      "4MB L3 cache",
      "Radeon Vega 8 Graphics",
      "PCIe 3.0 support"
    ],
    specifications: {
      brand: "AMD",
      model: "3200G",
      cores: 4,
      threads: 4,
      baseSpeed: "3.6 GHz",
      maxSpeed: "4.0 GHz",
      cache: "4MB L3"
    }
  },
  {
    id: 27,
    name: "Crucial BX500 480GB",
    description: "SATA SSD with up to 540 MB/s read speed",
    price: 13998,
    originalPrice: 16797,
    image: crucialBX500480GBImage,
    category: "storage",
    rating: 4.6,
    discount: 17,
    stock: 30,
    quantity: 1,
    sold: 15,
    features: [
      "480GB storage capacity",
      "540 MB/s read speed",
      "500 MB/s write speed",
      "SATA interface",
      "3-year warranty"
    ],
    specifications: {
      brand: "Crucial",
      model: "BX500",
      capacity: "480GB",
      interface: "SATA",
      readSpeed: "540 MB/s",
      writeSpeed: "500 MB/s"
    }
  },
  {
    id: 28,
    name: "Toshiba P300 1TB",
    description: "SATA HDD for mass storage",
    price: 13998,
    originalPrice: 16797,
    image: toshibaP3001TBImage,
    category: "storage",
    rating: 4.5,
    discount: 17,
    stock: 20,
    quantity: 1,
    sold: 10,
    features: [
      "1TB storage capacity",
      "7200 RPM",
      "64MB cache",
      "SATA interface",
      "2-year warranty"
    ],
    specifications: {
      brand: "Toshiba",
      model: "P300",
      capacity: "1TB",
      interface: "SATA",
      rpm: "7200",
      cache: "64MB"
    }
  },
  {
    id: 29,
    name: "Redragon K630",
    description: "Mechanical keyboard with RGB and numpad",
    price: 16797,
    originalPrice: 19596,
    image: redragonK630Image,
    category: "peripherals",
    rating: 4.5,
    discount: 14,
    stock: 15,
    quantity: 1,
    sold: 8,
    features: [
      "Outemu Blue switches",
      "RGB backlighting",
      "Aluminum frame",
      "Wired connectivity",
      "PBT keycaps"
    ],
    specifications: {
      brand: "Redragon",
      model: "K630",
      type: "Mechanical",
      switches: "Outemu Blue",
      connectivity: "Wired",
      backlight: "RGB"
    }
  },
  {
    id: 30,
    name: "Logitech G102",
    description: "Gaming mouse with RGB lighting",
    price: 13998,
    originalPrice: 16797,
    image: logitechG102Image,
    category: "peripherals",
    rating: 4.6,
    discount: 17,
    stock: 18,
    quantity: 1,
    sold: 9,
    features: [
      "8000 DPI sensor",
      "RGB lighting",
      "Lightweight design",
      "Wired connectivity",
      "Programmable buttons"
    ],
    specifications: {
      brand: "Logitech",
      model: "G102",
      sensor: "8000 DPI",
      connectivity: "Wired",
      buttons: "6",
      weight: "85g"
    }
  }
];

export const getProductById = (id: string): Product | undefined => {
  const productId = parseInt(id);
  if (isNaN(productId)) return undefined;
  return products.find((product) => product.id === productId);
};